<template>
  <div>
    <base-header class="pb-8 pt-4" />
    <div class="container-fluid mt--7">
      <b-row>
        <b-col sm="12" md="6">
          <b-card :title="$t('Şahıs Bilgileri')">
            <b-form-group label="Ad Soyad">
              <b-form-input v-model="form.full_name"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('Kan Grubu')">
              <b-form-input v-model="form.blood_type"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('Ise Giris Tarihi')">
              <b-form-input
                type="date"
                v-model="form.start_date"
              ></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('Maasi')">
              <b-form-input v-model="form.salary"></b-form-input>
            </b-form-group>
            <b-form-checkbox
              id="checkbox-1"
              v-model="form.is_sale"
              name="checkbox-1"
              :value="1"
              :unchecked-value="0"
            >
              {{ $t('Satış Personeli') }}
            </b-form-checkbox>
          </b-card>
        </b-col>

        <b-col sm="12" md="6">
          <b-card :title="$t('Iletisim Bilgileri')">
            <b-form-group :label="$t('E-mail Adresi')">
              <b-form-input v-model="form.email"></b-form-input>
            </b-form-group>

            <b-form-group :label="$t('Şifre')">
              <b-form-input
                type="password"
                v-model="form.password"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="GSM">
              <b-form-input
                v-model="form.gsm"
                v-mask="'+90 (###) ### ####'"
              ></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('Adres')">
              <b-form-input v-model="form.address"></b-form-input>
            </b-form-group>
          </b-card>
        </b-col>

        <b-col sm="12" class="text-right">
          <b-button variant="primary" @click="submit">
            {{ buttonText }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'CreateEmployee',
  data() {
    return {
      form: {
        full_name: '',
        phone: '',
        gsm: '',
        email: '',
        address: '',
        blood_type: '',
        start_date: '',
        salary: '',
        password: '',
        is_sale: 1,
      },
    };
  },
  computed: {
    id() {
      return !!this.$route.params.id;
    },
    buttonText() {
      return this.id ? 'Çalışan Düzenle' : 'Çalışan Oluştur';
    },
  },
  methods: {
    ...mapActions(['getEmployee', 'createEmployee', 'updateEmployee']),
    submit() {
      if (this.id) {
        this.updateEmployee({
          id: this.$route.params.id,
          employee: this.form,
        })
          .then((response) => {
            this.success(response.data.message);
            this.$router.push({ name: 'employees-and-salaries' });
          })
          .catch((error) => {
            this.error(error.response.data);
          });
      } else {
        this.createEmployee(this.form)
          .then((response) => {
            this.success(response.data.message);
            this.$router.push({ name: 'employees-and-salaries' });
          })
          .catch((error) => {
            this.error(error.response.data);
          });
      }
    },
  },
  mounted() {
    if (this.id) {
      this.getEmployee(this.$route.params.id)
        .then((response) => {
          this.form = response.data;
        })
        .catch(() => {
          this.$router.push({ name: 'all-employees' });
        });
    }
  },
};
</script>
